// extracted by mini-css-extract-plugin
module.exports = {"cursor":"cursor-module--cursor--PRAji","cursorText":"cursor-module--cursorText--cblSz","isDown":"cursor-module--isDown--3g3v5"};